import { Outlet, Route, Routes } from "react-router-dom";
import Login from "./pages/member/Login";
import Layout from "./components/common/Layout";
import Transaction from "./pages/transaction/Transaction";
import Sales from "./pages/sales/Sales";
import Member from "./pages/member/Member";
import Settings from "./pages/settings/Settings";
import OtherBranch from "./pages/otherBranch/OtherBranch";
import NotFound from "../user/pages/NotFound";
import ErrorPage from "./components/common/ErrorPage";

const Console = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route
                    path=""
                    element={
                        <Layout>
                            <Outlet />
                        </Layout>
                    }
                >
                    {/* 메인 */}
                    <Route path="transaction" element={<Transaction />} />
                    <Route path="sales" element={<Sales />} />
                    <Route path="member" element={<Member />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="other-branch" element={<OtherBranch />} />
                    <Route path="/*" element={<ErrorPage />} />
                </Route>
            </Routes>
        </div>
    );
};

export default Console;
